import { useState } from "react";

import dynamic from "next/dynamic";

import {
  Autoplay,
  EffectFade,
  Mousewheel,
  Navigation,
  Pagination,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";

import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import CardMakeDifferent from "./CardMakeDifferent";

const PostSlider = dynamic(() => import("components/organisms/PostSlider"), {
  ssr: false,
});

const WMUDSlider = ({ data }) => {
  const swiper = {
    direction: "vertical",
    preloadImages: false,
    lazy: true,
    autoHeight: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 800,
    fadeEffect: { crossFade: true },
    virtualTranslate: true,
    effect: "fade",
    mousewheel: true,
    pagination: {
      el: ".bbc-slide-pagination",
      clickable: true,
      bulletClass: "bbc-pagination-bullet block my-1",
      bulletActiveClass: "bbc-pagination-bullet-active h-10 w-2.5",
    },
    slidesPerView: "auto",
    spaceBetween: 0,
  };
  const [screen, setScreen] = useState();

  useResizeScreenModified(setScreen);

  return (
    <div className="container h-auto overflow-auto lg:h-[550px] lg:overflow-hidden">
      {screen === "DESKTOP" ? (
        <div className={" relative "}>
          <Swiper
            modules={[Navigation, Pagination, Autoplay, Mousewheel, EffectFade]}
            {...swiper}
          >
            {Array.isArray(data) &&
              data.length > 0 &&
              data.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <div
                      className=" flex text-left"
                      style={{ height: "550px" }}
                    >
                      <CardMakeDifferent
                        title={item.title}
                        description={item.description}
                        src={item.img_src}
                        width={item.width}
                        height={item.height}
                        alt={item.img_alt}
                        listWithIcon={item.listWithIcon}
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
            <div
              className={
                "bbc-slide-pagination absolute right-0 z-10 -translate-y-1/2 pt-6"
              }
              style={{
                top: "16rem",
              }}
            ></div>
          </Swiper>
        </div>
      ) : (
        <PostSlider
          navigation={false}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 50,
            },
          }}
        >
          {Array.isArray(data) &&
            data.length > 0 &&
            data.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="h-full ">
                    <CardMakeDifferent
                      title={item.title}
                      description={item.description}
                      src={item.img_src}
                      alt={item.img_alt}
                      width={item.width}
                      height={item.height}
                      rowReverse
                      listWithIcon={item.listWithIcon}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
        </PostSlider>
      )}
    </div>
  );
};

export default WMUDSlider;
